export const fullAccessGaleInstitutions = [
  'DEV',
  'TEST',
  'DEMO',
  'TESTING',
  'LIBRARIAN',
  'Carehope'
];
